import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import SignaturePad from 'signature_pad';
import { Data, imageEnumNameMap, ImageTypeEnum, SubmitData } from "src/app/dto";
import { DataService } from "src/app/service/data.service";
import { HttpFacetecService } from "src/app/service/http-facetec.service";
import { Config as FacetecConfig } from "src/assets/Config";
import { ToastrService } from "ngx-toastr";
import { RefService } from "src/app/service/ref.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: 'app-signature',
	templateUrl: './signature.component.html',
	styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements OnInit, AfterViewInit {

	data: Data;

	signatureNeeded!: boolean;
	signaturePad!: SignaturePad;
	@ViewChild('canvas') canvasEl!: ElementRef;
	signatureImg!: string;

	isLoading = false;
	showCheckingCredit = true;

	constructor(
		private toastr: ToastrService,
		private router: Router,
		private sanitizer: DomSanitizer,
		private dataService: DataService,
		private refService: RefService,
		private translateService: TranslateService,
		private facetecService: HttpFacetecService) {
	}

	// sleep(ms: number)
	sleep(ms: number) {
		return new Promise((resolve) => {
			setTimeout(resolve, ms);
		});
	}

	ngOnInit(): void {
		if (!this.refService.getRef()) {
			this.handleErrors("invalid.reference", "");
			return;
		}

		this.data = this.dataService.getData();
		this.sleep(2500).then(() => {
			this.showCheckingCredit = false;
		});
	}

	ngAfterViewInit(): void {
		this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
	}

	startDrawing(event: Event) {
		// works in device not in browser
	}
	moved(event: Event) {
		// works in device not in browser
	}
	savePad() {

	}
	clearPad() {
		this.signaturePad.clear();
	}

	submit() {
		this.signatureNeeded = this.signaturePad.isEmpty();
		if (this.signatureNeeded) {
			return;
		}

		const base64Data = this.signaturePad.toDataURL();
		var signature = this.data.imageList.filter(item => item.type === ImageTypeEnum.Signature)[0];
		if (signature) {
			signature.image = base64Data;
		} else {
			this.data.imageList.push({
				image: base64Data,
				type: ImageTypeEnum.Signature
			});
		}

		this.dataService.setData(this.data);
		this.sendToServer();
	}

	transformDataToSubmitData(data: Data): SubmitData {
		return {
			referenceId: this.refService.getRef(),
			firstName: data.firstName,
			lastName: data.lastName,
			idNumber: data.idNumber,
			country: data.country,
			nationality: data.nationality,
			dateOfBirth: data.dateOfBirth,
			dateOfExpiry: data.dateOfExpiration,
			dateOfIssue: data.dateOfIssue,
			placeOfBirth: data.placeOfBirth,
			sex: data.sex,
			uploadDocuments: data.imageList.map((item) => {
				return {
					name: imageEnumNameMap[item.type],
					data: item.image,
				};
			}),
		};
	}

	sendToServer() {
		this.isLoading = true;
		this.dataService.setData(this.data);
		try {
			this.facetecService.submit(this.transformDataToSubmitData(this.data)).subscribe(
				(data: any) => {
					if (data.responseCode === "0") {
						this.toastr.success("Data submitted successfully", "Success");
						setTimeout(() => {
							this.router.navigate(["/success"]);
							this.isLoading = false;
						}, 1500);
					} else {
						this.toastr.error(data.message, "Error");
						this.isLoading = false;
					}
				},
				(error) => {
					this.toastr.error(error.message, "Error");
					this.isLoading = false;
				},
			);
		} catch (error) {
			this.toastr.error(error.message, "Error");
			this.isLoading = false;
		}
	}

	private handleErrors(translateKey: string, result?: string): boolean {
		this.translateService.get(translateKey).subscribe((res: string) => {
			let message = res;
			if (!res || res.length <= 0) {
				message = result;
			}

			this.toastr.error(message, "Error");
		});

		return true;
	}
}